module.exports = __webpack_public_path__ + "img/IMG025.55c64321.jpg";